module.exports = __webpack_public_path__ + "img/pollManagement.a09bd7b8.svg";